"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconBin', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M5,18 L5,4 L15,4 L15,18 L5,18 Z M8,16 C8.553,16 9,15.553 9,15 L9,7 C9,6.447 8.553,6 8,6 C7.447,6 7,6.447 7,7 L7,15 C7,15.553 7.447,16 8,16 Z M12,16 C12.553,16 13,15.553 13,15 L13,7 C13,6.447 12.553,6 12,6 C11.447,6 11,6.447 11,7 L11,15 C11,15.553 11.447,16 12,16 Z M17,2 L16,2 L13,2 L13,1 C13,0.447 12.553,0 12,0 L8,0 C7.447,0 7,0.447 7,1 L7,2 L4,2 L3,2 C2.447,2 2,2.447 2,3 C2,3.553 2.447,4 3,4 L3,19 C3,19.553 3.447,20 4,20 L16,20 C16.553,20 17,19.553 17,19 L17,4 C17.553,4 18,3.553 18,3 C18,2.447 17.553,2 17,2 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;